import {
  Box,
  Divider,
  // Flex,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
// import { Link } from "react-router-dom"

import { fetchInventory } from "areas/product/store/actions"
import { openModal } from "components/modal"
import { jewlr_t, isTestMode, IS_JEWLR } from "helpers/application"
import { showHolidayShippingInfoPDP } from "helpers/holiday"

import { ActionBtn } from "./components"
import InstantGiftText from "./instant-gift-text"
import ShipText from "./ship-text"

const InternalShipDetails = ({
  hasSize,
  showInstantGift,
  showInventoryTable,
  ship,
  forHer,
}) => {
  const RegularView = () => (
    <>
      <ShipText />
      {IS_JEWLR() && showInstantGift && <InstantGiftText />}
      {/* <Typography fontSize="14px" mt={3}>
            We also offer Buy Online & Pick Up at
          </Typography>
          <Typography fontSize="14px" fontWeight="300">
            5000 Dufferin St Unit Q, North York, ON M3H 5T5
          </Typography> */}
    </>
  )

  const CertificateView = () => {
    return (
      <>
        <ShipText />
        <Box py="10px">
          <Divider
            bg="grey.20"
            my={1}
            width={{ _: "115px", desktop: "180px" }}
          />
        </Box>
        <Typography
          color="black"
          fontSize="16px"
          fontWeight="700"
          letterSpacing="-0.03em"
          lineHeight="16px"
        >
          Need it now? We&apos;ve got you with Instant Gift
        </Typography>
        <Typography
          color="black"
          letterSpacing="-0.03em"
          lineHeight="16px"
          mb="10px"
          px={{ _: 5, desktop: 0 }}
        >
          {showHolidayShippingInfoPDP() && forHer
            ? `Order now and share your ${jewlr_t(
                "terms.personalized"
              )} video preview
            on ${sl.config.guaranteed_holiday}!`
            : "Send an Instant Gift Video."}
        </Typography>
        <ActionBtn
          fontSize="14px"
          fontWeight="700"
          letterSpacing="-0.03em"
          lineHeight="16px"
          onClick={() => {
            openModal("#instant-gift-explained")
            if (!isTestMode) {
              dataLayer.push({
                event: "clicked-need-it-now-pdp",
              })
            }
          }}
        >
          {showHolidayShippingInfoPDP() && forHer
            ? "Learn More"
            : "What is an Instant Gift?"}
        </ActionBtn>
        {/* <Flex justifyContent="center">
          <ActionBtn onClick={() => openModal("#instant-gift-explained")}>
            Instant Gift Video
          </ActionBtn>
          <ActionBtn forwardedAs={Link} to="/info/gift_cards">
            E-Gift Card
          </ActionBtn>
        </Flex> */}
      </>
    )
  }

  // const AvailableHolidayView = () => (
  //   <>
  //     <Typography bold color="sale" letterSpacing="0.7px" mb={1}>
  //       ARRIVES IN TIME FOR {sl.config.guaranteed_holiday.toUpperCase()}
  //     </Typography>
  //     <ShipText />
  //   </>
  // )

  // LIVE INVENTORY MESSAGING

  // Prompt user to select metal/size
  const InventoryChooseOptionsView = () => (
    <div>
      <ShipText />
      <Typography color="neutral" fontSize={14} mb={1} mt={2}>
        This item arrives after {sl.config.guaranteed_holiday_alias} in the
        selected metal{hasSize && " and size"}. It is available for{" "}
        {sl.config.guaranteed_holiday_alias} Delivery in other metals
        {hasSize && " and sizes"}.
      </Typography>
      <ActionBtn onClick={() => showInventoryTable()}>
        See what&apos;s available
      </ActionBtn>
    </div>
  )

  const content = {
    AVAILABLE_HOLIDAY: () => RegularView(),
    CERTIFICATE: () => CertificateView(),
    INVENTORY_CHOOSE_OPTIONS: () => InventoryChooseOptionsView(),
    INVENTORY_UNAVAILABLE: () => InventoryChooseOptionsView(),
    REGULAR: () => RegularView(),
  }

  return <div>{(content[ship.view_type] || content["REGULAR"])()}</div>
}

const mapStateToProps = (state) => {
  const isAccessory = state.wizard.description.product_type === "ACCESSORY"

  return {
    forHer: state.wizard.forHer,
    hasSize: !!(state.wizard.data && state.wizard.data.sz),
    ship: state.wizard.shipping.main,
    showInstantGift: !isAccessory,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showInventoryTable: () => {
      openModal("#inventory")
      dispatch(fetchInventory())
    },
    // toggleCertificateModal: () => openModal("#certificate"),
  }
}

InternalShipDetails.propTypes = {
  forHer: PropTypes.bool,
  hasSize: PropTypes.bool,
  ship: PropTypes.object,
  showInstantGift: PropTypes.bool,
  showInventoryTable: PropTypes.func,
  // toggleCertificateModal: PropTypes.func,
}

const ShipDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalShipDetails)

export default ShipDetails
